
import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";

import ConsultaCentroCusto from '../../../../../lib/json/consultas/CentroCustoSelect.json'

import LoadingSpinner from "../../../../components/LoadinSpinner";
import InputGeral from "../../../../components/InputGeral/Index";
import { useNavigate, useParams } from "react-router-dom";
import SubmitForm from "../../../../components/SubmitForm";
import { ErroMsg, SucessoMsg } from "../../../../contents/VariaveisGlobais";
import { toast } from "react-toastify";
import ConsumoTOTVS_POST from "../../../../../backend/ConsumoTotvs";
import TitlePageTotvs from "../../../../components/TitlePageTotvs";
import { ConsultaTotvsEmpresa } from "../../../../../backend/ConsultaTotvsEmpresa";
import SelectComprador from "../../../../components/Select/Comprador";

function FichaCentroCusto(){
    const navigate = useNavigate();
    const isFormVisual = window.location.href.includes('Visualizar');
    
    // define a exibição do Loading
    var [carregar, setCarregar] = useState(false);
    const [disabledForm, setDisabledForm] = useState(isFormVisual);

    const { idCentroCusto, empresaFilialCompras } = useParams();
    
    const [empresaFilialSelect, setEmpresaFilialSelect] = useState(empresaFilialCompras);
    const [empresaFilial, setEmpresaFilial] = useState(empresaFilialCompras);

    // Consulta do grid
    var consultaDefault  = ConsultaCentroCusto.consulta + (idCentroCusto ? ` WHERE CTT_CUSTO = '${idCentroCusto}'` : '');

    const [campoCodigo, setCampoCodigo]       = useState('0');
    const [campoDescricao, setCampoDescricao] = useState('');
    const [campoComprador, setCampoComprador] = useState({value: '', label: 'Selecione o Comprador'});

    useEffect(() => {
        if (idCentroCusto){
            loadCentroCusto();
        }
    }, []);

    // Processa consulta do grid
    const loadCentroCusto = async () => {
        setCarregar(true);
        
        var retConsulta = await ConsultaTotvsEmpresa( consultaDefault, ConsultaCentroCusto.tabelas, empresaFilial.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresaFilial.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) );
        
        if (retConsulta.data){
            setCampoCodigo(retConsulta.data[0].CTT_CUSTO);
            setCampoDescricao(retConsulta.data[0].CTT_DESC01);
            setCampoComprador({value: retConsulta.data[0].Y1_USER.trim(), label: retConsulta.data[0].CTT_XCOMDF.trim() ? retConsulta.data[0].CTT_XCOMDF + ' - ' + retConsulta.data[0].Y1_NOME : 'Selecione o Comprador'});
        }
        
        setCarregar(false);
    }

    const handleSalvar = async() =>{
        const cJSON = { 
            ACAO: idCentroCusto ? 'INCLUIR' : 'ALTERAR',
            CTT_CUSTO: campoCodigo,
            CTT_DESC01: campoDescricao,
            CTT_XCOMDF: ( campoComprador.label && campoComprador.label.trim() ? campoComprador.label.split(' - ')[0] : '' )
        }

        setCarregar(true);
        const oRetorno = await ConsumoTOTVS_POST('CENTROCUSTO', cJSON, empresaFilial)

        if (oRetorno.error == '00'){
            SucessoMsg(oRetorno.description)
        }else{
            ErroMsg(oRetorno.description)
        }
    }

    const handleEmpresaFilial = (e) => {
        setEmpresaFilialSelect(e)
        setEmpresaFilial(e.value)
    }

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePageTotvs 
                        text="Centro de Custo" 
                        empresa={empresaFilialSelect} 
                        empresaFilial={empresaFilial} 
                        changeEmpresa={handleEmpresaFilial}
                    />
                </Col>
            </Row>
            { empresaFilial &&
                <>
                    <Row>
                        <Col md="2" xs="12">
                            <InputGeral 
                                label="Código"
                                tipo='text'
                                value={campoCodigo}  // Define o valor do campo com base no estado
                                onChange={(e) => setCampoCodigo(e.target.value)}
                                disabled={!idCentroCusto || disabledForm }                    
                            />
                        </Col>

                        <Col md="5" xs="12">
                            <InputGeral 
                                label="Descrição"
                                tipo='text'
                                value={campoDescricao}  // Define o valor do campo com base no estado
                                onChange={(e) => setCampoDescricao(e.target.value)}
                                disabled={!idCentroCusto || disabledForm}
                            />
                        </Col>

                        <Col md="5" xs="12">
                            <SelectComprador
                                campoComprador={campoComprador}
                                changeComprador={setCampoComprador}
                                empresaLogada={empresaFilial}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                </>
            }
            
            <SubmitForm 
                onSave={ disabledForm ? null : handleSalvar}
                onCancel={ disabledForm ? null : "handleCancelar"}
                onVoltar={ disabledForm ? "handleVoltar" : null}
            />
        </>
    );
}

export default FichaCentroCusto;